// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-text-input__table .message-editor__container {
    position: absolute;
    bottom: 0rem;
    right: 0rem;
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: #f5f5f5;
}

.operator-text-input__table .message-to-edit {
    display: flex;
    flex-direction: column;
    margin: 0 0.5rem;
}

.operator-text-input__table .message-to-edit__header {
    text-align: left;
    font-weight: 500;
    display: flex;
}

.operator-text-input__table .message-to-edit__text {
    text-align: left;
    text-overflow: ellipsis;
    white-space: pre-line;
    overflow: hidden;
    margin-bottom: .5rem;
    min-height: 2.4rem;
    resize: none;
    max-height: calc(1.5em * 10);
    overflow-y: auto;
}

.operator-text-input__table .message-editor {
    display: flex;
    flex-direction: row;
    margin: 0 0.5rem;
}

.message-to-edit__footer {
    border-bottom: 1px solid black;
    margin-bottom: 0.5em;
}

.operator-text-input__table .message-to-edit__close-editor {
    margin-left: auto;
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
}

.operator-text-input__table .message-to-edit__close-editor:hover {
    color: #7f8c8d;
}

.message-editor .message-editor__remove-message {
    background-color: #d22e37;
    margin-left: 0.2rem;
}

.edit-message-buttons {
    display: flex;
    position: relative;
    top: -6px;
}

.message-editor .message-editor__input {
    overflow: hidden;
    resize: none;
    width: 100%;
    border: none;
    border-bottom: #9e9e9e solid 1px;
    background-color: transparent;
    border-radius: 0;
    outline: none;
    font-size: 1rem;
    margin: 0 0 0.4rem 0;
    padding: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
}

.message-editor__input:hover,
.message-editor__input:focus {
    border: none;
    transition: none;
    box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/app/chat/message-editor/MessageEditor.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".operator-text-input__table .message-editor__container {\r\n    position: absolute;\r\n    bottom: 0rem;\r\n    right: 0rem;\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.operator-text-input__table .message-to-edit {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0 0.5rem;\r\n}\r\n\r\n.operator-text-input__table .message-to-edit__header {\r\n    text-align: left;\r\n    font-weight: 500;\r\n    display: flex;\r\n}\r\n\r\n.operator-text-input__table .message-to-edit__text {\r\n    text-align: left;\r\n    text-overflow: ellipsis;\r\n    white-space: pre-line;\r\n    overflow: hidden;\r\n    margin-bottom: .5rem;\r\n    min-height: 2.4rem;\r\n    resize: none;\r\n    max-height: calc(1.5em * 10);\r\n    overflow-y: auto;\r\n}\r\n\r\n.operator-text-input__table .message-editor {\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 0 0.5rem;\r\n}\r\n\r\n.message-to-edit__footer {\r\n    border-bottom: 1px solid black;\r\n    margin-bottom: 0.5em;\r\n}\r\n\r\n.operator-text-input__table .message-to-edit__close-editor {\r\n    margin-left: auto;\r\n    cursor: pointer;\r\n    width: 1.5rem;\r\n    height: 1.5rem;\r\n    border-radius: 50%;\r\n}\r\n\r\n.operator-text-input__table .message-to-edit__close-editor:hover {\r\n    color: #7f8c8d;\r\n}\r\n\r\n.message-editor .message-editor__remove-message {\r\n    background-color: #d22e37;\r\n    margin-left: 0.2rem;\r\n}\r\n\r\n.edit-message-buttons {\r\n    display: flex;\r\n    position: relative;\r\n    top: -6px;\r\n}\r\n\r\n.message-editor .message-editor__input {\r\n    overflow: hidden;\r\n    resize: none;\r\n    width: 100%;\r\n    border: none;\r\n    border-bottom: #9e9e9e solid 1px;\r\n    background-color: transparent;\r\n    border-radius: 0;\r\n    outline: none;\r\n    font-size: 1rem;\r\n    margin: 0 0 0.4rem 0;\r\n    padding: 0;\r\n    -webkit-box-shadow: none;\r\n    box-shadow: none;\r\n    -webkit-box-sizing: content-box;\r\n    box-sizing: content-box;\r\n}\r\n\r\n.message-editor__input:hover,\r\n.message-editor__input:focus {\r\n    border: none;\r\n    transition: none;\r\n    box-shadow: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
